<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{ $t('text.report') }}</span>
    </div>
    <div class="page-card-content organisation-reporting-content">
      <div class="mt-20 page-content">
        <div class="secondary-font mb-20">
          {{ $t('text.reporting_page_desc') }}:
        </div>
        <div class="module-title mb-10">
          {{ $t('text.baseline_trial_periods') }}
        </div>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="80px"
          size="small"
        >
          <el-form-item :label="$t('text.baseline')">
            <el-date-picker
              v-model="form.baseline"
              type="daterange"
              :range-separator="$t('text.to').toLowerCase()"
              :start-placeholder="$t('text.start')"
              :end-placeholder="$t('text.end')"
              :format="userLang.indexOf('en') > -1 ? 'dd MMM yy' : 'dd/MM/yy'"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('text.trial')">
            <el-date-picker
              v-model="form.trial"
              type="daterange"
              :range-separator="$t('text.to').toLowerCase()"
              :start-placeholder="$t('text.start')"
              :end-placeholder="$t('text.end')"
              :format="userLang.indexOf('en') > -1 ? 'dd MMM yy' : 'dd/MM/yy'"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              class="save-btn min-w-100"
              :loading="saveLoading"
              @click="saveBaselineTrial"
              >{{ $t('text.save').toUpperCase() }}</el-button
            >
          </el-form-item>
        </el-form>
        <el-divider />
        <div class="module-title mb-10">
          <span>{{ $t('text.rounds_shifts') }}</span>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            class="ml-15"
            @click="openAddRoundDialog()"
          ></el-button>
        </div>
        <el-table
          border
          size="mini"
          :data="roundsList"
          v-loading="shiftLoading"
        >
          <el-table-column :label="$t('text.name')" prop="name">
            <template slot-scope="scope">
              {{ scope.row.ShiftName }}
            </template>
          </el-table-column>
          <el-table-column label="Item" prop="item">
            <template slot-scope="scope">
              {{ scope.row.ShiftStart }} -
              {{ scope.row.ShiftEnd }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('text.action')">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                size="mini"
                @click="editRoundItem(scope.row)"
              ></el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="removeRoundItem(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-divider /> -->
        <!-- <div>
          <span class="secondary-font"
            >{{ $t('text.to_access_reports_go_to') }}
            <span class="text-a">Smartz Report</span>
            {{ $t('text.portal') }}</span
          >
        </div> -->
      </div>
    </div>
    <AddRound ref="addRound" />
  </div>
</template>

<script>
import AddRound from '@/components/report/AddRound'
import moment from 'moment'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      moment,
      userLang: 'navigator.language || navigator.userLanguage',
      form: {
        baseline: [],
        trial: []
      },
      roundsList: [],
      rules: {
        baseline: [
          {
            required: true,
            message: this.$t('text.pleae_select'),
            trigger: 'change'
          }
        ],
        trial: [
          {
            required: true,
            message: this.$t('text.pleae_select'),
            trigger: 'change'
          }
        ]
      },
      saveLoading: false,
      shiftLoading: false
    }
  },
  components: {
    AddRound
  },
  mounted() {
    this.getRounds()
    this.getBaselineTrial()
  },
  methods: {
    openAddRoundDialog() {
      this.$refs.addRound.openDialog()
    },
    editRoundItem(item) {
      this.$refs.addRound.openDialog()
      this.$refs.addRound.form = {
        id: item.Id,
        name: item.ShiftName,
        round: [
          moment('2023-10-27 ' + item.ShiftStart).valueOf(),
          moment('2023-10-27 ' + item.ShiftEnd).valueOf()
        ]
      }
    },
    removeRoundItem(item) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.you_are_about_to_remove_this_item'
        )}</div>` + `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.are_you_sure'),
        {
          confirmButtonText: this.$t('text.yes').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        this.handleDeleteRound(item)
      })
    },
    handleDeleteRound(item) {
      this.shiftLoading = true
      ApiService.DeleteOrgShif(item.Id)
        .then(response => {
          this.shiftLoading = false
          if (response.data.success) {
            this.getRounds()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.shiftLoading = false
        })
    },
    async getRounds() {
      this.shiftLoading = true
      await ApiService.GetOrganisationShift(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          this.shiftLoading = false
          if (response.data.success) {
            this.roundsList = response.data.data
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed')
            })
          }
        })
        .catch(() => {
          this.shiftLoading = false
          swal({
            icon: 'error',
            title: this.$t('text.failed')
          })
        })
    },
    async getBaselineTrial() {
      await ApiService.GetOrganisationBaselineTrial(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          if (response.data.success) {
            let data = response.data.data
            if (data.BaselineDate) {
              this.form.baseline = [
                moment(data.BaselineDate.StartDate).format(
                  'YYYY-MM-DD HH:mm:ss'
                ),
                moment(data.BaselineDate.EndDate).format('YYYY-MM-DD HH:mm:ss')
              ]
            }
            if (data.TrialDate) {
              this.form.trial = [
                moment(data.TrialDate.StartDate).format('YYYY-MM-DD HH:mm:ss'),
                moment(data.TrialDate.EndDate).format('YYYY-MM-DD HH:mm:ss')
              ]
            }
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed')
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            title: this.$t('text.failed')
          })
        })
    },
    saveBaselineTrial() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.saveLoading = true
          ApiService.SaveOrganisationBaselineTrial({
            OrganisationId: this.$store.getters[`user/selecteOrganisationId`],
            BaselineStartDate: moment(this.form.baseline[0]).format(
              'YYYY-MM-DD 00:00:00'
            ),
            BaselineEndDate: moment(this.form.baseline[1]).format(
              'YYYY-MM-DD 00:00:00'
            ),
            TrialStartDate: moment(this.form.trial[0]).format(
              'YYYY-MM-DD 00:00:00'
            ),
            TrialEndDate: moment(this.form.trial[1]).format(
              'YYYY-MM-DD 00:00:00'
            )
          })
            .then(response => {
              this.saveLoading = false
              if (response.data.success) {
                swal({
                  icon: 'success',
                  title: this.$t('text.saved_successfully')
                })
              } else {
                swal({
                  icon: 'error',
                  title: this.$t('text.saved_failed')
                })
              }
            })
            .catch(() => {
              this.saveLoading = false
              swal({
                icon: 'error',
                title: this.$t('text.saved_failed')
              })
            })
        }
      })
    }
  }
}
</script>
